export const GA_TRACKING_ID = process.env.GA_TRACKING_ID;

// gtag is missing on the server, in dev and behind ad blockers; analytics
// must never break the page that calls it.
const gtagReady = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  if (!gtagReady()) return;
  window.gtag("config", GA_TRACKING_ID, {
    page_location: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  if (!gtagReady()) return;
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};
